import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Neighborhoods = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddNeighborhood = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditNeighborhood = () => {
  return (
    
      
        <Edit />
      
    
  );
};
